module.exports = __webpack_public_path__ + "img/quick-icon01.9c0f2841.png";